import { render } from "./NextSteps.vue?vue&type=template&id=6e6480fc&ts=true"
import script from "./NextSteps.vue?vue&type=script&lang=ts"
export * from "./NextSteps.vue?vue&type=script&lang=ts"

import "./NextSteps.vue?vue&type=style&index=0&id=6e6480fc&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__